class mainMenuDropdown {
    constructor() {
        this.menuLink = document.querySelectorAll('#main-menu .nav__item.has-submenu')

        this.events()
    }
    events() {
        this.menuLink.forEach((el) => {
            el.addEventListener('mouseenter', () => {
                let submenu = el.querySelector('.nav__submenu')
                let bounds = submenu.getBoundingClientRect()

                if (bounds.right > window.innerWidth) {
                    submenu.classList.add('align-menu-left')
                } else {
                    return
                }
            })
        })
    }
}
export default mainMenuDropdown
